var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMessageNotif(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/linear/message-notif"
  }, /*#__PURE__*/React.createElement("g", {
    id: "message-notif"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M18.3327 8.33342V10.8334C18.3327 14.1667 16.666 15.8334 13.3327 15.8334H12.916C12.6577 15.8334 12.4077 15.9584 12.2493 16.1667L10.9993 17.8334C10.4493 18.5667 9.54935 18.5667 8.99935 17.8334L7.74935 16.1667C7.61602 15.9834 7.30768 15.8334 7.08268 15.8334H6.66602C3.33268 15.8334 1.66602 15.0001 1.66602 10.8334V6.66675C1.66602 3.33341 3.33268 1.66675 6.66602 1.66675H11.666",
    stroke: "",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M16.2493 5.83341C17.3999 5.83341 18.3327 4.90067 18.3327 3.75008C18.3327 2.59949 17.3999 1.66675 16.2493 1.66675C15.0988 1.66675 14.166 2.59949 14.166 3.75008C14.166 4.90067 15.0988 5.83341 16.2493 5.83341Z",
    stroke: "",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M13.3301 9.16667H13.3375",
    stroke: "",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M9.99607 9.16667H10.0036",
    stroke: "",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M6.66209 9.16667H6.66957",
    stroke: "",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageNotif);
export default __webpack_public_path__ + "static/media/message-notif.73967223443b3cda0aa8ccf9deb60c7c.svg";
export { ForwardRef as ReactComponent };